import React from 'react';
import { DetailPanelData } from '../../../Common/DetailPanel';
import { FormatDate } from '../../../../utils';

const AssetStatusDetails = ({
    data: {
        acquisitionDate = null,
        disbursementDate = null,
        installDate = null,
        assetStatusName = '',
        alternateLeakDetectionMethod
    } = {},
    // selectedRegulatedAssetTypes
}) => {

    return (
        <>
            <DetailPanelData id='StatusHeader' title="ASSET STATUS" data={assetStatusName} />
            <DetailPanelData id='InstallDateHeader' title="INSTALL DATE" data={FormatDate(installDate)} />
            <DetailPanelData
                id='HasApprovedAlternateLeakDetectionHeader'
                title="ALTERNATE LEAK DETECTION METHOD"
                data={typeof alternateLeakDetectionMethod === 'boolean' ? (alternateLeakDetectionMethod ? 'Approved' : 'Disapproved') : ''}
            />
            <DetailPanelData id='AcquisitionDateHeader' title="ACQUISITION DATE" data={FormatDate(acquisitionDate)} />
            {disbursementDate !== null && <DetailPanelData id='DisbursementDateHeader' title="DISBURSEMENT DATE" data={FormatDate(disbursementDate)} />}
            {/*<DetailPanelData id='RegulatedAssets' title="U.S.-based Regulations" data={selectedRegulatedAssetTypes} />*/}
        </>
    )
}

export default AssetStatusDetails;